var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy-policy-wrap"},[_c('div',{staticClass:"privacy-policy link"},[_vm._v("手机号仅限您参加活动目的使用，除此之外不会用于其他途径")])])}]

export { render, staticRenderFns }